import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import ArchiveIcon from '@mui/icons-material/Archive';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import ExportTableAction from 'src/components/ExportTableAction';
import { ExportTypeType } from 'src/types/table';
import TransportsSectionTopBlock from '../TransportsSection/TopBlock';

type TopBlockProps = {
    reloadTransportsList: () => void;
    permissionCreate: boolean;
    permissionUpdate: boolean;
    handleExport: (type: ExportTypeType) => void;
    archive: boolean;
    permissionArchive: boolean;
    setArchive: (value: boolean) => void;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate(`/transports/new`);
    };

    return (
        <TransportsSectionTopBlock
            actions={[
                {
                    node: (
                        <ExportTableAction
                            title={translate('transports.action.exportFile')}
                            handleExport={props.handleExport}
                        />
                    ),
                    hidden: props.archive,
                },
                {
                    onClick: () => props.setArchive(!props.archive),
                    icon: <ArchiveIcon />,
                    label: translate('archive.toggle'),
                    tooltip: translate('archive.tooltip'),
                    variant: 'outlined',
                    active: props.archive,
                    hidden: !props.permissionArchive,
                    'data-testid': 'archive-toggle',
                },
                {
                    onClick: props.reloadTransportsList,
                    icon: <ReloadIcon />,
                    tooltip: translate('transports.action.synchronizeTable'),
                    variant: 'outlined',
                },
                {
                    label: translate('transports.action.createNew'),
                    onClick: handleNew,
                    icon: <AddIcon />,
                    hidden: props.archive || !props.permissionCreate,
                },
            ]}
        />
    );
};

export default TopBlock;
